/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useRef } from 'react'
import { useGLTF } from '@react-three/drei'

export default function Model(props) {
  const { nodes, materials } = useGLTF('assets/glb-file/20.glb')
  return (
    <group {...props} dispose={null}>
      <group scale={0.01}>
        <mesh geometry={nodes.sailboat1.geometry} material={nodes.sailboat1.material} />
      </group>
    </group>
  )
}

//useGLTF.preload('assets/glb-file/20.glb')
